import { useStyles } from './styles'
import cn from 'classnames'

export const RoadcastRainbow = ({ flip }) => {
  const classes = useStyles()

  return (
    <div className={classes.wrapper}>
      {flip ? (
        <>
          <div className={cn(classes.line, classes.yellow)} />
          <div className={cn(classes.line, classes.orange)} />
          <div className={cn(classes.line, classes.lightGreen)} />
          <div className={cn(classes.line, classes.darkGreen)} />
        </>
      ) : (
        <>
          <div className={cn(classes.line, classes.darkGreen)} />
          <div className={cn(classes.line, classes.lightGreen)} />
          <div className={cn(classes.line, classes.orange)} />
          <div className={cn(classes.line, classes.yellow)} />
        </>
      )}
    </div>
  )
}
